import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useState } from 'react';

import { getCurrentUser } from '@/api/auth';

import { useAppDispatch, useAppSelector } from '@/hooks/redux';

import { setLoggedInUser } from '@/redux/auth/actions';
import { selectConfigsState } from '@/redux/configs';

import { ICBResponseCode } from '@/types/user';

import { getPlatform } from '@/utils/browser';

export function useICBChecking() {
  const [fetchingStarted, setStartFetching] = useState(false);
  const { links } = useAppSelector(selectConfigsState);
  const dispatch = useAppDispatch();
  const { data, isLoading } = useQuery({
    queryKey: ['icb-checking-user'],
    queryFn: () => getCurrentUser(false),
    retry: false,
    enabled: fetchingStarted,
    refetchOnWindowFocus: false,
  });
  const { isAndroid, isIOS, isIPadOS } = getPlatform();

  useEffect(() => {
    const timer = setTimeout(() => setStartFetching(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (data && data.user.icbResponseCode !== ICBResponseCode.Success) {
      dispatch(setLoggedInUser(data.user));
    }
  }, [data, dispatch]);

  const onGoBanking = useCallback(() => {
    if (isIOS || isIPadOS) {
      window.location.assign(links.icbIOS);
    } else if (isAndroid) {
      window.location.assign(links.icbAndroid);
    } else {
      window.location.assign(links.icbWeb);
    }
  }, [
    isAndroid,
    isIOS,
    isIPadOS,
    links.icbAndroid,
    links.icbIOS,
    links.icbWeb,
  ]);

  return {
    isLoading: !fetchingStarted || isLoading,
    onGoBanking,
  };
}
